import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import JsonExcel from '../node_modules/vue-json-excel'
import babelPolyfill from 'babel-polyfill';
import VueHtml2Canvas from 'vue-html2canvas';

Vue.use(VueHtml2Canvas);
import VueElementLoading from '../node_modules/vue-element-loading'
import avisoModal from './componentes/Modal/ModalAviso'
import pantallaCarga from './componentes/ImgLoading/loading.vue'
import VueRecaptcha from '../node_modules/vue-recaptcha';
//import pantallaCarga from './componentes/ImgLoading/loading.vue'
//import VueElementLoading from '../node_modules/vue-element-loading'
import Vuetify from 'vuetify'

// Alerts
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import SmartTable from "vuejs-smart-table";


Vue.component('ElementLoading', VueElementLoading)
Vue.component('downloadExcel', JsonExcel)
Vue.component('app-modal', avisoModal)
//Vue.component('ElementLoading', VueElementLoading)
Vue.component('app-loading', pantallaCarga)
Vue.component('vueRecaptcha',VueRecaptcha)



Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(VueHtml2Canvas);
Vue.use(require('vue-moment'));

// Alerts
Vue.use(VueSweetalert2);

Vue.use(Vuetify)
Vue.use(SmartTable)
Vue.prototype.$log = console.log.bind(console)


new Vue({
    el: '#app',
    router: router,
    store: store,
    icons,
    template: '<App/>',
    components: {
        App
    }
})